/** Vite injects a same-origin directory whose name covers every decoder byte. */
declare const __READOS_PDF_DECODER_PATH__:string;

/** Shared by the reader and real decoding tests; PDF.js appends fixed filenames. */
export function pdfDocumentOptions(url:string,wasmUrl?:string){
 return {url,withCredentials:true,wasmUrl:wasmUrl??new URL(__READOS_PDF_DECODER_PATH__,document.baseURI).href};
}
